import React from "react";
import { Message } from "semantic-ui-react";

const Saturation = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      width: "100vw",
      position: "fixed",
      bottom: "20px",
      padding: "0px 20px",
    }}
  >
    <Message negative>
      <Message.Header>¡Lo sentimos!</Message.Header>
      <p>
        Estamos saturados de pedidos por lo que la página web estará disponible
        hasta la próxima semana.
      </p>
    </Message>
  </div>
);

export default Saturation;
